import { Component, OnInit, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { InstallationDetailsStore } from '@store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BuildingInfo } from '@vi-iot/client';

import { ImmediateStateMatcher, PATTERN } from '@common';

@Component({
  selector: 'app-edit-owner-card-dialog',
  templateUrl: './edit-owner-card-dialog.component.html',
  styleUrls: ['./edit-owner-card-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditOwnerCardDialogComponent implements OnInit, OnDestroy {
  private readonly ngUnsubscribe = new Subject<void>();
  matcher = new ImmediateStateMatcher();
  buildingInfo: FormGroup;
  addressInfo: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<EditOwnerCardDialogComponent>,
    private installationDetailsStore: InstallationDetailsStore
  ) {}

  ngOnInit(): void {
    this.installationDetailsStore.installationBuildingInfo$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((buildingInfo) => {
        this.buildingInfo = new FormGroup({
          buildingName: new FormControl(buildingInfo.buildingName, [Validators.maxLength(512)]),
          buildingEmail: new FormControl(buildingInfo.buildingEmail, [
            Validators.pattern(PATTERN.EMAIL),
            Validators.maxLength(300),
          ]),
          buildingPhone: new FormControl(buildingInfo.buildingPhone, [
            Validators.pattern(PATTERN.PHONE),
            Validators.minLength(6),
            Validators.maxLength(30),
          ]),
        });
      });

    this.installationDetailsStore.installationAddressInfo$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((addressInfo) => {
        this.addressInfo = new FormGroup({
          street: new FormControl(addressInfo.street, [
            Validators.maxLength(128),
            Validators.required,
          ]),
          houseNumber: new FormControl(addressInfo.houseNumber, [
            Validators.maxLength(32),
            Validators.required,
          ]),
          city: new FormControl(addressInfo.city, [Validators.maxLength(128), Validators.required]),
          zip: new FormControl(addressInfo.zip, [Validators.maxLength(64), Validators.required]),
        });
      });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    const buildingInfo: BuildingInfo = {
      ...this.buildingInfo.value,
      address: this.addressInfo.value,
    };

    this.installationDetailsStore.updateBuildingInfo(buildingInfo);
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
